import { Component, OnInit } from "@angular/core";
import { locale as italian } from "../../../../../i18n/it";
import { AuthenticationService, UserService } from "../../../../../auth/service";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute } from "@angular/router";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-future-employees",
  templateUrl: "./future-employees.component.html",
  styleUrls: ["./future-employees.component.scss"],
})
export class FutureEmployeesComponent implements OnInit {
  public contentHeader: IContentHeader;
  public user_type_name: string = italian.data.TITLES.FUTURE_EMPLOYEE;
  public futureEmployees: any = [];
  public tableLimit: number = 10;
  public searchKey: string = "";
  public filteredFutureEmployees: any = [];
  public selectedAsset: any = null;
  public toggleModalAssociate: boolean = false;
  public AssetIdSelectedForAssociate: number = 0;
  public selectedEmployee: any = null;
  public newEmail: any = "";
  public suggestEmail: string = "";

  constructor(
    private _userService: UserService,
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    public _modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
  ) {
    this._utilService.disableAutoHideLoading();
    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.searchKey = params.hasOwnProperty("q") ? params.q : "";
    });
    this.contentHeader = {
      headerTitle: this.user_type_name,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.USERS,
            isLink: false,
          },
          {
            name: italian.data.TITLES.FUTURE_EMPLOYEE,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    await this.loadFutureEmployees();
    await this.searchFutureEmployees();
  }

  async loadFutureEmployees() {
    this.futureEmployees = await this._userService.getFutureEmployees();
    this._utilService.hideLoading();
  }

  async searchFutureEmployees() {
    const key: string = this.searchKey.trim().toLowerCase();
    let filteredFutureEmployees: any = this.futureEmployees;
    if (key.length > 0) {
      filteredFutureEmployees = filteredFutureEmployees.filter((item: any) => item.complete_name.toLowerCase().includes(key));
    }
    this.filteredFutureEmployees = filteredFutureEmployees;
  }

  updateTableLimit(event: any) {
    this.tableLimit = Number(event.target.value);
  }

  public modalOpen(modalBasic: any, futureEmployee: any) {
    const emailDomain = this._utilService.themeConfiguration.email_domain;
    this.selectedEmployee = null;
    this.selectedEmployee = futureEmployee;
    const [firstname, ...others]: string[] = this.selectedEmployee.complete_name.split(" ");
    const lastname = others.join("");
    this.suggestEmail = firstname[0].toLowerCase() + "." + lastname.toLowerCase() + emailDomain;
    this._modalService.open(modalBasic, {
      size: "sm",
      centered: true,
    });
    this.newEmail = "";
    if (this.selectedEmployee && this.selectedEmployee.email && this.selectedEmployee.email.length > 0 && this.selectedEmployee.email.includes(emailDomain)) {
      this.newEmail = this.selectedEmployee.email;
    }
    this.selectedAsset = null;
  }

  async assignEmail() {
    if (!this._authenticationService.hasCapability("assign_office_email")) {
      window.history.back();
      return false;
    }
    if (!this.newEmail || this.newEmail.length < 1) {
      await this._utilService.showSWALError({ text: "ERROR_INVALID_EMAIL" });
      return false;
    }
    const data = {
      email: this.newEmail,
    };
    await this._userService
      .update(this.selectedEmployee.hash, data)
      .then(async () => {
        this._utilService.hideLoading();
        await this.loadFutureEmployees();
        await this.searchFutureEmployees();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_ASSIGN_EMAIL" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "SUCCESS_ASSIGN_EMAIL" });
      });
  }

  //Funzioni associazione modale
  showModalAdd(futureEmployee: any) {
    this.toggleModalAssociate = true;
    this.AssetIdSelectedForAssociate = null;
    this.selectedEmployee = futureEmployee;
  }

  async onAssociateModalFormEvent() {
    await this.loadFutureEmployees().then(async () => {
      await this.searchFutureEmployees();
    });
  }
  //END Funzioni associazione modale
}
